import {
  DaysInSeconds,
  MinutesInHour,
  SecondsInHour,
} from 'shared/hooks/use-timer'

export const getTimeLeft = (dateString?: string): number => {
  if (!dateString) return 0

  const [datePart, timePart] = dateString.split(' ')
  const [day, month, year] = datePart.split('.').map(Number)
  const [hours, minutes, seconds] = timePart.split(':').map(Number)

  const targetDate = new Date(
    Date.UTC(year, month - 1, day, hours, minutes, seconds),
  )
  const diffMs = targetDate.getTime() - Date.now()

  return Math.max(0, Math.floor(diffMs / 1000))
}

export const startTimerInit = (seconds: number) => {
  let seconds_ = seconds

  const timer = () => {
    const days = Math.floor(seconds_ / DaysInSeconds)
    const hours = Math.floor((seconds_ % DaysInSeconds) / SecondsInHour)
    const minutes = Math.floor((seconds_ % SecondsInHour) / MinutesInHour)

    seconds_ -= 1

    return {
      days,
      hours,
      minutes,
    }
  }

  return timer
}
